import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/classnames/index.js';
import styles from './index.module.scss.js';

var Column = function (_a) {
    var children = _a.children, size = _a.size, isVcentered = _a.isVcentered, isRightAligned = _a.isRightAligned, isNarrow = _a.isNarrow, isWide = _a.isWide, isGapless = _a.isGapless, className = _a.className;
    return (jsx("div", __assign({ className: classNames(isVcentered && "middle aligned", isRightAligned && "right aligned", size, isNarrow && styles.isNarrow, isWide && "wide", isGapless && styles.isGapless, "column", className) }, { children: children }), void 0));
};

export { Column as default };
